import React from 'react';

import './style.scss';
import { HomeIcon } from 'components/icons/HomeIcon';

export default function BackToHomeButton() {
  const handleClick = () => {
    const currentHost = window.location.hostname;
    const is360 = currentHost.startsWith('360.');
    const targetHost = is360
      ? currentHost.replace('360.', '')
      : 'duanbconsolary.com.vn';

    const targetUrl = `https://${targetHost}`;
    window.location.href = targetUrl;
  };

  return (
    <div className="backtohome">
      <div className="backtohome-btn" onClick={handleClick}>
        <HomeIcon />
      </div>
    </div>
  );
}
